import { observer } from 'mobx-react-lite'
import { layoutStore } from 'shared/layout'
import { TrialSubscriptionBanner } from 'entities/Subscription/ui/TrialSubscriptionBanner/ui/TrialSubscriptionBanner'
import { CanceledSubscriptionBanner } from 'entities/Subscription/ui/CanceledSubscriptionBanner/ui/CanceledSubscriptionBanner'
import { CallingBanner } from 'entities/Compliance/ui/CallingBanner/ui/CallingBanner'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const GlobalBanners = observer(() => {
  const { authStore } = useEntitiesContext()

  if (layoutStore.isMobileView || !authStore.isLoggedIn || !authStore.isRefresh) return null

  return (
    <>
      <TrialSubscriptionBanner />
      <CanceledSubscriptionBanner />
      <CallingBanner />
    </>
  )
})
